export function redirectTo(url: string) {
  window.location.replace(url);
}
